import { ALPHANUMERIC_CHAR_TYPES } from "@/utils/checkCharTypeValidator";
import { validator } from "@/utils/validator";

export const masterDataLocalGovernmentCounterSchema = validator.object().shape({
  officeName: validator.string().emptyToNull().label("受領官署名").required(),
  bmOfficeRenewVisaCsvCode: validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .isValidCheckCharType(ALPHANUMERIC_CHAR_TYPES)
    .length(3)
    .label("期間更新CSVのコード（列BM）")
    .required(),
  targetProvinces: validator.array().min(1, "対象の都道府県を選択してください。").label("対象の都道府県").required(),
  targetMunicipalities: validator.array().label("対象の市区町村（あれば）").notRequired(),
});
